// DesarrollosRouter.js
import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom'; // Import Routes and Route
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react"; // Import useLingui
import NewsHeader from '../components/NewsHeader/NewsHeader';
import DesarrollosPage from '../components/DesarrollosPage/DesarrollosPage';
import { useLocation } from 'react-router-dom';

const DesarrollosRouter = () =>
{
    const { pathname } = useLocation(); // esto es para que al clickear en una news, scrollee al top
    useEffect(() => {
    window.scrollTo(0, 0);
    }, [pathname]);
    const { i18n } = useLingui(); // Get the Lingui i18n object to access the current locale
    const titleLine1 = t`CONOZCA NUESTROS`;
    const titleLine2 = t`DESARROLLOS`;
    //const description = t`Para conocer más sobre nuestras acciones en el sector.`;
    //const button = t`CONOCER MÁS`;
        useEffect(() =>
	{
	    document.title = t`The Cosmic Shores - Desarrollos`
    }, [titleLine1])
    const currentLocale = i18n.locale;

    return (
        <div><NewsHeader titleLine1={titleLine1} titleLine2={titleLine2}/>
            <Routes>
                <Route path="/" element={<DesarrollosPage />} />
            </Routes>
        </div>
    );
};

export default DesarrollosRouter;

